/*
 * @Author: wangshengqiang
 * @Date: 2021-04-26 11:46:14
 * @LastEditTime: 2021-08-03 19:09:26
 * @LastEditors: wangshengqiang
 * @Description: 咨询按钮组件
 */
// import { ModuleContext } from '@/components/BaseModule';
import classnames from 'classnames';
import { stringify } from 'qs';
import React, { useContext } from 'react';
import { useLocation } from 'react-router';
import { Toast } from 'zarm';
import { getQueryParam } from '@/utils/queryString';
import { queryReservationConsultation } from '@/services/reservation';
import { getLocalClick } from '@/components/EventBtn/handleEvent';
import './index.less'; // 增加了咨询特殊逻辑的 操作栏icon按钮

const ConsultIconButton = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    events = {},
    label
  } = props;
  const {
    enable,
    fontClass
  } = attrs;
  const query = getQueryParam();

  if (events.type === 'link') {
    const urlData = {
      tenantId: query.channelCode,
      thirdOrderNo: query.thirdOrderNo,
      thirdOrderNoType: query.thirdOrderNoType
    };
    events.link = `${events.link}?${stringify(urlData)}`;
  }

  const onClickLocal = getLocalClick(events, (opts = {}, next) => {
    return next;
  });

  const onClick = async (...args) => {
    const params = getQueryParam();
    let result;

    try {
      // thirdOrderNo 渠道id / channelCode 租户id
      result = await queryReservationConsultation({
        thirdOrderNoType: params.thirdOrderNoType,
        thirdOrderNo: params.thirdOrderNo,
        tenantId: params.channelCode,
        canalDefine: params.canalDefine
      }); // channelId: 63148, tenantId: 100766
    } catch (error) {
      Toast.show('查询预约失败');
    }

    if (!result) return;

    if (result.success !== true) {
      Toast.show(result.message || '预约查询失败');
      return;
    } // 支持预约但没有配置二维码


    if (result.data.canSupportAppointment === 'Y' && !result.data.url) {
      Toast.show(result.message || '预约查询失败');
      return;
    }

    onClickLocal();
  };

  const cls = classnames({
    'components-customer-service-render': true
  });
  const iconCls = classnames({
    iconfont: true,
    [fontClass]: !!fontClass
  });
  if (!enable) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    onClick: () => onClick()
  }, /*#__PURE__*/React.createElement("i", {
    className: iconCls
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, label));
});
export default ConsultIconButton;